import { useEffect } from "react";
import { Calendar, Quote } from "lucide-react";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Sections";
import { discoveryQuotes } from "../data/discoveryQuotes";
import { siteConfig } from "../data/mock";
import "../App.css";

export default function ProblemsPage() {
  useEffect(() => {
    document.title = "Lab0 | Problems, in their own words";

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen bg-[#fafaf9] text-[#1a1a1a]">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative px-6 lg:px-8 pt-32 lg:pt-40 pb-16 lg:pb-20">
          <div className="max-w-7xl mx-auto w-full">
            <div className="font-mono text-xs uppercase tracking-[0.18em] text-emerald-700 mb-5">
              From discovery calls
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-[3.5rem] font-semibold text-[#1a1a1a] max-w-4xl leading-[1.05] mb-6">
              The problems, in their own words.
            </h1>
            <p className="text-base lg:text-lg text-[#1a1a1a]/45 max-w-3xl leading-relaxed">
              {discoveryQuotes.length} verbatim quotes from professional services,
              implementation, and delivery leaders. Unedited, unscripted&mdash;the
              reality of enterprise software rollouts.
            </p>
            <div className="hero-actions mt-9" aria-label="Actions">
              <a
                className="primary-action"
                href={siteConfig.demoUrl}
                target="_blank"
                rel="noreferrer"
              >
                <Calendar size={18} aria-hidden="true" />
                Book a demo
              </a>
            </div>
          </div>
        </section>

        {/* Quote grid */}
        <section className="relative px-6 lg:px-8 pb-24 lg:pb-32">
          <div className="max-w-7xl mx-auto w-full">
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-px bg-black/[0.06] border border-black/[0.06]">
              {discoveryQuotes.map((item, i) => (
                <article
                  key={`${item.theme}-${i}`}
                  className="bg-white p-8 lg:p-9 flex flex-col group hover:bg-emerald-700/[0.02] transition-colors duration-500"
                >
                  <div className="flex items-center justify-between gap-3 mb-5">
                    <span className="font-mono text-[0.7rem] uppercase tracking-[0.08em] font-bold text-emerald-700">
                      {item.theme}
                    </span>
                    <span className="font-mono text-[0.7rem] text-[#1a1a1a]/30 text-right">
                      {item.signal}
                    </span>
                  </div>
                  <p className="font-display text-lg text-[#1a1a1a]/85 leading-snug flex-1">
                    <Quote
                      size={16}
                      aria-hidden="true"
                      className="inline-block mr-2 -translate-y-0.5 text-emerald-700/40"
                    />
                    {item.quote}
                  </p>
                  <div className="text-sm text-[#1a1a1a]/40 mt-6 pt-4 border-t border-black/[0.06]">
                    {item.role}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
